export default __webpack_public_path__ + "static/media/menu.95c5efbc.svg";